import { useEffect, useMemo, useState } from "react";
import NavBar from "../../component/navBar/NavBar";
import Title from "../../component/title/Title";
import LiveMap from "../../component/map/LiveMap";
import "./MapOverview.css";
import useVehicleWebSocket from "../../config/utilities/useVehicleWebSocket";

export default function MapOverview() {
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const { dispatchData, loading } = useVehicleWebSocket({ requireCoordinates: true });

  const vehicleOptions = useMemo(() => {
    return dispatchData.map((item) => {
      const vehicleNumber = item.vehicleDetails?.vehicleNumber || "Unnamed vehicle";
      const busNumber = item.vehicleDetails?.busNumber;
      const tripName = item.tripName;
      
      let label = busNumber ? `${vehicleNumber} (${busNumber})` : vehicleNumber;
      
      // Add trip name to the label if it exists
      if (tripName) {
        label += ` - ${tripName}`;
      }
      
      return {
        label,
        value: item.documentId,
        status: item.status,
      };
    });
  }, [dispatchData]);

  useEffect(() => {
    const isStillVisible = dispatchData.some(
      (item) => item.documentId === selectedVehicle
    );
    if (!isStillVisible) setSelectedVehicle("");
  }, [dispatchData, selectedVehicle]);

  return (
    <div className="main-page">
      <NavBar type="mapOverview" />
      <div className="content-area map-overview-content-area">
        <div className="title-container map-overview-title-container">
          {" "}
          <Title
            title="Map Overview"
            subtitle="A bird’s eye view of all vehicles currently on trips"
            titleSize="1.5rem"
            subtitleSize="1rem"
            gap="0.5rem"
            lineHeight="2rem"
          />
        </div>
        <div className="main-content-container map-overview-main-content-container">
          <div className="live-map-container map-overview-live-map-container">
            <LiveMap
              liveData={dispatchData}
              selectedVehicle={selectedVehicle}
              setSelectedVehicle={setSelectedVehicle}
              vehicleOptions={vehicleOptions}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
